import React, { Component } from 'react';
import Card from '../components/ProjectCard';
import druma_img_1 from '../img/druma_project.JPG';
import druma_img_2 from '../img/druma_project2.JPG'
import ansible_img_1 from '../img/ansible_project.png'
import ansible_img_2 from '../img/ansible_project2.PNG'
import alumni_img_1 from '../img/alumni_project.JPG'
import alumni_img_2 from '../img/alumni_project2.jpg'

class Project extends Component {
    render() {
        return (
            <div className="condiv">
            <h1 className="subtopic">Projects</h1>
            <Card title="Druma" 
                img_project_1={druma_img_1}
                img_project_2={druma_img_2}
                img_style_1 = "project_image"
                img_style_2 = "project_image" 
                description=
                "Druma is an AI system for detecting potentialy dangerous trees along the power line Right of Way.
                Druma is designed to detect trees and power line from satellite imagery or UAVs images. The detected trees will be marked accordingly
                based on their horizontal distance from the nearest power line" 
                link="https://github.com/gelarpambudi/druma"/>

            <Card title="Server Provisioning & Automation with Ansible" 
                img_project_1={ansible_img_1}
                img_project_2={ansible_img_2}
                img_style_1 = "project_image"
                img_style_2 = "project_image_phone"
                description=
                "This project is about provisioning server application with Ansible. Our main objectives are
                install and deploy NGINX Load Balancer with its backend services configuration and create health check automation that will send notification
                status to Telegram Bot." 
                link="https://github.com/gelarpambudi/ansible-et4044"/>

            <Card title="Alumni Mobile App" 
                img_project_1={alumni_img_1}
                img_project_2={alumni_img_2} 
                img_style_1= "project_image"
                img_style_2= "project_image_phone"
                description=
                "Android app for managing alumni data in the database. The mobile app will make a request to the web service, 
                then the web service will process the request." 
                link="https://github.com/gelarpambudi/alumni-mobile-app"/>
            </div>
            )
        }
    }
    
export default Project